/**
 * API Configuration
 * Automatically uses production URLs in production build
 */

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
export const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:3001';
export const LIVEKIT_URL = process.env.REACT_APP_LIVEKIT_URL || '';
const DEFAULT_ICE_SERVERS = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' }
];

const parseIceServers = () => {
  const raw = process.env.REACT_APP_WEBRTC_ICE_SERVERS;
  if (!raw) return DEFAULT_ICE_SERVERS;
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) return DEFAULT_ICE_SERVERS;
    return parsed;
  } catch (_) {
    return DEFAULT_ICE_SERVERS;
  }
};

export const WEBRTC_ICE_SERVERS = parseIceServers();

// Helper for making API requests
export const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;
  const response = await fetch(url, options);
  return response;
};
